import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import LeaderItem from './LeaderItem';
import { getLeaderBoard } from '../callGraphql';
import { Box, Flex } from '@chakra-ui/react';

import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { useSelector } from 'react-redux';

const StyledWrap = styled.div`
  width: 100%;
  overflow: auto;
`;

const THItem = styled.th`
  padding: 10px 12px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  border-bottom: none;
  font-family: inherit;
  margin-left: 20px;
  color: #fff;
`;

const StyledHeadingTR = styled.tr`
  background-color: var(--card-color);
  height: 50px;
  border-radius: 6px;
`;

const StyledTable = styled.table`
  width: 100%;
  border: 2px solid var(--card-color);
  overflow: auto;
  .highline {
    background: #fff200;
    td div {
      margin-left: 24px;
      color: #000;
    }
  }
`;

const StyledTableUser = styled.table`
  width: 100%;
  border: 2px solid var(--card-color);
  overflow: auto;
  margin-top: 20px;
  tbody tr {
    background: #fff200;
    td div {
      margin-left: 24px;
      color: #000;
    }
  }
`;

const WrapBox = styled.div`
  margin-top: 1rem;
  margin-bottom: 3rem;
`;

const WrapSelectTitle = styled.div`
  margin-bottom: 25px;
  .MuiSelect-select {
    color: #10c6ac;
    font-size: 18px;
  }
  .MuiInputBase-root:hover{
    .MuiOutlinedInput-notchedOutline{
      border-color: #fff;
    }
  }
  .MuiOutlinedInput-notchedOutline{
    border-color: #fff;
  }
  svg{
    color: #fff;
  }
`

const ItemSelect = styled.div`
  color: #10c6ac;
  font-size: 18px;
`

export default function LeaderBoard() {
  const { walletAddress } = useSelector((state) => state);
  const [data, setData] = useState({
    data: [],
    yourData: null,
    rank: 0
  })
  const [pool, setPool] = useState(1)

  useEffect(()=>{
    getLeaderBoard(pool, walletAddress).then(res=>{
      const [result] = res
      setData({
        data: result?.leaderBoard?.results,
        yourData:  result?.leaderBoard?.yourData,
        rank:  result?.leaderBoard?.yourRank,
      })
    })
  }, [pool, walletAddress])

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setPool(value)
  };

  return (
    <StyledWrap>
      <WrapBox>
        <WrapSelectTitle>
          <FormControl>
            <InputLabel htmlFor="grouped-native-select">Select pool</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={pool}
              label="Select pool"
              onChange={handleChange}
            >
              <MenuItem value={1}><ItemSelect>Pool 180 days, rank II</ItemSelect></MenuItem>
              <MenuItem value={2}><ItemSelect>Pool 180 days, rank III</ItemSelect></MenuItem>
              <MenuItem value={3}><ItemSelect>Pool 180 days, rank IV</ItemSelect></MenuItem>
            </Select>
          </FormControl>
        </WrapSelectTitle>
        <StyledTable>
          <thead>
            <StyledHeadingTR>
              <THItem>Wallet Address</THItem>
              <THItem>Total Amount</THItem>
              <THItem>Rank</THItem>
            </StyledHeadingTR>
          </thead>
          <tbody>
            {Array.isArray(data?.data) &&
              data.data.map((item, index) => {
                return <LeaderItem key={index + 'key1'} item={item} rank={index + 1} yourData={data?.yourData} />;
              })}
          </tbody>
        </StyledTable>
        <StyledTableUser>
          <tbody>
          {data?.yourData && data?.rank && data?.rank > (pool*5 +5) && <LeaderItem key='yourdata' item={data?.yourData} rank={data?.rank} yourData={data?.yourData} /> }
          </tbody>
        </StyledTableUser>
        {Array.isArray(data?.data) &&
          data.data?.length === 0 && (
            <Flex justify='center' flexDirection='column' align='center'>
              <Box fontSize='20px' color='#8e8e91' mt='1rem'>
                No data to display
              </Box>
            </Flex>
          )}
      </WrapBox>
    </StyledWrap>
  );
}
